const PaymentPageStyles = {
    wrapper: `container flex flex-col justify-center items-center w-full pb-2`,
    wrap_things: `w-full flex flex-col gap-10
                  md:w-[600px]
    `,
    timer_details: ``
}
export { PaymentPageStyles}